var _g, _g2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_d_1776_36374)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.8794,
    cy: 65.0571,
    r: 50,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_f_1776_36374)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.8379,
    cy: 65.0156,
    r: 29.9585,
    fill: "url(#paint0_linear_1776_36374)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.8379,
    cy: 65.0156,
    r: 29.9585,
    fill: "url(#paint1_radial_1776_36374)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4699 59.4067C53.6268 53.4997 53.5274 38.0259 65.4738 38.0259C77.4203 38.0259 77.313 53.4997 65.4699 59.4067ZM65.4699 59.4067C87.0774 63.9276 95.7077 89.4368 65.4699 85.9048M65.4699 59.4067C45.6121 63.8885 33.3341 93.3613 71.8279 91.2513",
    stroke: "#6C9DDE",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8794 47.6196V59.6196M80.8794 53.6196H92.8794",
    stroke: "#6C9DDE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1776_36374",
    x: 0.879395,
    y: 0.0571289,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1776_36374"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1776_36374",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1776_36374",
    x: 3.87939,
    y: 3.05713,
    width: 123.917,
    height: 123.917,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_1776_36374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1776_36374",
    x1: 53.3282,
    y1: 38.7731,
    x2: 82.0803,
    y2: 89.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#4FBAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#1285E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1776_36374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.1504 67.9961) rotate(37.4762) scale(27.9847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAdd);
export default __webpack_public_path__ + "static/media/ProfileAdd.81273453c2261cadfa078a1f8d59e20c.svg";
export { ForwardRef as ReactComponent };